
// Enum for audience type
export enum AudienceType {
  SINGLE_USER = "SINGLE_USER",
  ALL_USERS = "ALL_USERS",
}

// Human-readable labels
export const AudienceTypeLabel: Record<AudienceType, string> = {
  [AudienceType.SINGLE_USER]: "Single User",
  [AudienceType.ALL_USERS]: "All Users",
};

// Colors for tags or chips
export const audienceColors: Record<AudienceType, string> = {
  [AudienceType.SINGLE_USER]: "purple",
  [AudienceType.ALL_USERS]: "blue",
};

// Notification read status
export enum NotificationStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}
